import api from '../api'; // your configured axios instance
import { API_URL } from '../config';

// Function to register a new employee
export async function registerEmployee(employeeData) {
  try {
    const response = await api.post('/employees/register', employeeData);
    console.log('Registration successful:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error registering employee:', error);
    throw error;
  }
}

// Function to fetch all employees
export async function getAllEmployees() {
  try {
    const response = await api.get('/employees');
    return response.data;
  } catch (error) {
    console.error('Error fetching employees:', error);
    throw error;
  }
}

export async function deleteEmployee(employeeId) {
  try {
    const response = await api.delete(`/employees/${employeeId}`);
    console.log('Delete response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error deleting employee:', error);
    throw error;
  }
}

export async function getEmployeeImage(employeeId) {
  try {
    const response = await api.get(`/employees/image/${employeeId}`, {
      responseType: 'blob'
    });

    // Check if response is actually an image
    if (response.data instanceof Blob && response.data.type.startsWith('image/')) {
      return URL.createObjectURL(response.data);
    }
    
    console.log(`No image found for employee ${employeeId}`);
    return null;
  } catch (error) {
    if (error.response?.status === 404) {
      console.log(`No image found for employee ${employeeId}`);
      return null;
    }
    console.error('Error fetching employee image:', error);
    return null;
  }
}

// Function to update an employee
export async function updateEmployee(employeeId, employeeData) {
  try {
    const response = await api.put(`/employees/${employeeId}`, employeeData);
    console.log('Update successful:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error updating employee:', error);
    throw error;
  }
}
// services/employeeService.js
export async function updateMyImage(file) {
  const formData = new FormData();
  formData.append('file', file); // 'file' matches @RequestParam("file")

  try {
    const response = await api.post('/employees/me/image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    console.log('Image updated:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error uploading image:', error);
    throw error;
  }
}

// Function to fetch all offboarding records
export async function getAllOffboardings() {
  try {
    const response = await api.get('/offboarding');
    return response.data;
  } catch (error) {
    console.error('Error fetching offboardings:', error);
    throw error;
  }
}

export async function startOffboarding(employeeId, offboardingData) {
  try {
    console.log('Starting offboarding for employeeId:', employeeId, 'with data:', offboardingData);
    const response = await api.post(`/offboarding/start/${employeeId}`, offboardingData);
    console.log('Offboarding started, response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error starting offboarding:', error);
    throw error;
  }
}

export async function updateOffboarding(offboardingId, offboardingData) {
  try {
    console.log('Updating offboardingId:', offboardingId, 'with data:', offboardingData);
    const response = await api.put(`/offboarding/${offboardingId}`, offboardingData);
    console.log('Offboarding updated, response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error updating offboarding:', error);
    throw error;
  }
}

export async function getHrStaff() {
  try {
    const response = await api.get('/hr-staff');
    return response.data;
  } catch (error) {
    console.error('Error fetching HR staff:', error);
    throw error;
  }
}

// Function to fetch an employee by ID
export async function getEmployeeById(employeeId) {
  try {
    const response = await api.get(`/employees/${employeeId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching employee:', error);
    throw error;
  }
}

// Function to fetch offboarding by ID
export async function getOffboardingById(offboardingId) {
  try {
    const response = await api.get(`/offboarding/${offboardingId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching offboarding:', error);
    throw error;
  }
}

export async function deleteOffboarding(offboardingId) {
  try {
    const response = await api.delete(`/offboarding/${offboardingId}`);
    console.log('deleteOffboarding response: Success');
    return response.data || {};
  } catch (error) {
    console.error('Error deleting offboarding:', error);
    throw error;
  }
}

export async function getMyProfile() {
  try {
    const response = await api.get('/me');
    return response.data;
  } catch (error) {
    console.error('Error fetching profile:', error);
    throw error;
  }
}
// Ideally pass an object like { projectName: '...', secondProjectName: '...' }
export async function updateMyProjects(projectData) {
  try {
    // We use api.put because we are updating data
    const response = await api.put('/me/projects', projectData);
    return response.data;
  } catch (error) {
    console.error('Error updating projects:', error);
    throw error;
  }
}
export async function updateMyPositions(positionData) {
  try {
    // PUT because we are updating logged-in employee positions
    const response = await api.put('/me/positions', positionData);
    return response.data;
  } catch (error) {
    console.error('Error updating positions:', error);
    throw error;
  }
}
// Function to fetch employees by joining month and year
export async function getEmployeesByJoiningMonth(month, year) {
  try {
    const response = await api.get('/joining/monthly', {
      params: { month, year }
    });
    console.log('Fetched employees by joining month:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching employees by joining month:', error);
    throw error;
  }
}

// Function to fetch employees by joining year
export async function getEmployeesByJoiningYear(year) {
  try {
    const response = await api.get('/joining/yearly', {
      params: { year }
    });
    console.log('Fetched employees by joining year:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching employees by joining year:', error);
    throw error;
  }
}

// Function to fetch all positions
export async function getAllPositions() {
  try {
    const response = await api.get('/employees/positions');
    return response.data;
  } catch (error) {
    console.error('Error fetching all positions:', error);
    throw error;
  }
}